'use client';

import React, { useState, useCallback } from 'react';
import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import BrandSection from './components/BrandSection';
import ServicesSection from './components/ServicesSection';
import WhyChooseSection from './components/WhyChooseSection';
import SpaceSection from './components/SpaceSection';
import HowItWorksSection from './components/HowItWorksSection';
import BookingSection from './components/BookingSection';
import CtaSection from './components/CtaSection';
import ContactSection from './components/ContactSection';
import SiteFooter from './components/SiteFooter';
import WhatsAppButton from './components/WhatsAppButton';

export default function HomePage() {
  const [selectedServiceIds, setSelectedServiceIds] = useState<string[]>([]);

  const handleServicesChange = useCallback((ids: string[]) => {
    setSelectedServiceIds(ids);
  }, []);

  return (
    <div className="min-h-screen bg-ivory">
      <SiteHeader />
      <main>
        <HeroSection />
        <BrandSection />
        <ServicesSection onSelectionChange={handleServicesChange} />
        <WhyChooseSection />
        <SpaceSection />
        <HowItWorksSection />
        <BookingSection preSelectedIds={selectedServiceIds} />
        <CtaSection />
        <ContactSection />
      </main>
      <SiteFooter />
      <WhatsAppButton />
    </div>
  );
}